<div class="container py-5">
    <h2>Políticas</h2>
    <p>Puedes consultar nuestras políticas de privacidad y términos de servicio en los siguientes enlaces:</p>
    <ul>
        <li><a href="https://www.wescotcorporation.com/privacypolicy">Política de Privacidad</a></li>
        <li><a href="https://www.wescotcorporation.com/termsofservice">Términos del Servicio</a></li>
    </ul>
</div>